'use strict';

function CompanyLogoService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/logo');
}

angular.module('dokiv')
  .factory('CompanyLogoService', ['$resource', 'config', CompanyLogoService]);





//////////////////
// WEBPACK FOOTER
// ./scripts/company/CompanyLogoService.js
// module id = 35
// module chunks = 0